import { Component, inject, OnInit } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs";

import { AdaaHelper } from "./core/utils";
import { Constants } from "./shared/constants/constants";
import { Language } from "./shared/constants/enums";
import { AppTitleService, LanguageService } from "./shared/services";

@Component({
  selector: "adaa-root",
  imports: [RouterOutlet],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
})
export class AdaaComponent implements OnInit {
  private _appTitleService = inject(AppTitleService);
  private _router = inject(Router);
  private _languageService = inject(LanguageService);

  private get _routeChanges$() {
    return this._router.events.pipe(filter((event) => event instanceof NavigationEnd));
  }

  public ngOnInit() {
    this._setAdaaLanguage();
    this._appTitleService.changeTitle(this._routeChanges$);
    this._appTitleService.changeTitle(this._languageService.hasChanged$);
  }

  private _setAdaaLanguage(): void {
    let localStorageLang = AdaaHelper.getLocalStorage(Constants.localStorageKeys.language) as Language | null;

    if (!localStorageLang) {
      localStorageLang = Language.Arabic;

      AdaaHelper.setLocalStorage(Constants.localStorageKeys.language, Language.Arabic, "string");
    }

    if (localStorageLang !== Language.English && localStorageLang !== Language.Arabic) {
      localStorageLang = Language.Arabic;
    }

    this._languageService.initLang(localStorageLang);
  }
}
